<template>
  <div class="doc">
    <div class="title">
      <h1>用户服务协议</h1>
    </div>
    <div class="article">
      <dl>
        <dd>
          用户服务协议是您（下称“用户”）与{{app}}（手机软件）服务提供者（下称“{{app}}”）之间就{{app}}账号的注册和使用签订的协议。{{app}}（手机软件）是指{{app}}相关APP软件（下称“{{app}}软件”或“本软件”）。
        </dd>

        <dt><b>1、重要须知</b></dt>
        <dd><b>1.1 </b>用户欲注册和使用{{app}}软件，必须事先认真阅读、充分理解本协议中各条款，尤其应特别注意免除或者限制{{app}}责任的免责条款及对用户的权利限制条款。如用户不同意本协议，用户应不注册使用或主动取消{{app}}提供的服务。若用户使用第三方账号登录，也请用户务必认真阅读本协议，用户的使用行为将被视为对本协议的完全接受。</dd>
        <dd><b>1.2 </b>特别提醒：如用户是未成年人，请务必在监护人的陪同下阅读本协议，注册使用{{app}}软件，也请监护人切实履行监护责任。</dd>
        <dd><b>1.3 </b>在用户接受本协议之后，此文本可能因国家政策、产品以及履行本协议的环境发生变化而进行修改，修改后的协议发布在{{app}}所有产品（包含但不限于APP、网站）上。修改后的协议公布七日后即视为“{{app}}”已通知用户协议修改内容。若用户对修改后的协议有异议的，请立即停止访问、使用{{app}}软件，若用户继续访问或使用，视为对修改后的协议予以认可。</dd>
        <dd><b>1.4 </b>{{app}}目前向用户提供丰富的互联网服务，除了文字、图片资讯信息，还包括但不限于语音通讯、在线游戏、聊天室等，如果某一特定服务有单独的协议、规则、指引，用户须遵守该单独的协议、规则和指引，用户接受其他的所有服务均应遵守本协议。</dd>
        <dd><b>1.5 </b>{{app}}会在本协议的基础上，制定发布平台规则，平台规则是本协议的有效组成部分，用户对本协议的接受与遵守也视为对平台规则的接受与遵守。</dd>

        <dt><b>2、{{app}}账号规则</b></dt>
        <dd><b>2.1 </b>用户需通过实名手机号注册（升级）{{app}}账号，注册（升级）成功之后，{{app}}会按系统规则自动分配给用户一个号码，该号码即为{{app}}账号。用户需自行设置符合安全要求的密码。</dd>
        <dd><b>2.2 </b>{{app}}账号的性质是用户使用{{app}}服务的凭证，{{app}}账号的所有权属于{{app}}，用户仅有账号的使用权。</dd>
        <dd><b>2.3 </b>{{app}}账号还是用户持有、使用相关虚拟财产、道具的身份凭证。用户若需要接受{{app}}提供的增值服务，{{app}}账号同时也是用户支付费用、接受增值服务的凭证。</dd>
        <dd><b>2.4 </b>用户注册了{{app}}账号并不意味获得全部{{app}}产品的授权，仅仅是取得了接受{{app}}服务的身份，用户在登录相关网页、加载应用、下载安装软件、使用某些单项服务时需要另行签署单个产品/服务的授权协议。</dd>
        <dd><b>2.5 </b>用户可以按照{{app}}的业务规则用{{app}}账号登录和使用{{app}}提供的各种软件和服务。除了{{app}}提供的软件和服务，用户还可以用{{app}}账号登录使用{{app}}合作伙伴的相关服务。</dd>
        <dd><b>2.6 </b><U>{{app}}账号仅限于在{{app}}软件上使用用户手机号注册并实名认证，并仅供注册并实名认证用户本人使用，禁止账号的赠与、借用、租用、转让或售卖。</U></dd>
        <dd><b>2.7 </b>用户保证注册{{app}}账号时填写的身份信息是真实的，任何非法、不真实、不准确的用户信息所产生的责任由用户承担。用户应不断更新注册资料，符合及时、详尽、真实、准确的要求。所有原始键入的资料将引用用户的账号注册资料。如果因用户的注册信息不真实而引起的问题，以及对问题发生所带来的后果，{{app}}不负任何责任。</dd>
        <dd><b>2.8 </b>用户需保证{{app}}账号的昵称需符合《互联网用户账号名称管理规定》的要求，不得设置任何包含危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容作为昵称。</dd>
        <dd><b>2.9 </b>为了充分利用{{app}}账号资源，如果用户存在长期未登陆使用{{app}}账号的情形，{{app}}有权予以进行注销、回收、替换或采取删除该账户在{{app}}软件数据库中的任何记录（包括但不限于注册信息、虚拟礼物信息等）等清理措施，相应服务同时终止。{{app}}在对此类账户进行清理前，将以包括但不限于弹窗、公告、站内消息、客户端推送信息等方式通知用户。</dd>

        <dd><b>3、用户使用规则</b></dd>
        <dd><b>3.1 </b>用户保证使用{{app}}软件发布、传播的信息的真实性、准确性，同时保证不会利用{{app}}的服务制作、复制、发布、传播、存储含有下列内容的信息：</dd>
        <dd>（1）反对宪法所确定的基本原则的；</dd>
        <dd>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</dd>
        <dd>（3）损害国家荣誉和利益的；</dd>
        <dd>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</dd>
        <dd>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</dd>
        <dd>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</dd>
        <dd>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</dd>
        <dd>（8）侮辱或者诽谤他人，侵害他人知识产权或其他合法权益的；</dd>
        <dd>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</dd>
        <dd>（10）含有虚假、有害、胁迫、侵害他人隐私、中伤、低俗、或其它道德上令人反感的内容的；</dd>
        <dd>（11）含有法律、行政法规禁止的其他内容的。</dd>
        <dd><b>3.2 </b>用户不得在{{app}}软件上违规进行发布广告、销售商品的商业行为，包括但不限于以下行为：</dd>
        <dd>（1）发布宣传色情网站、成人用品网站等色情、低俗内容；</dd>
        <dd>（2）发布宣传假冒伪劣产品或未经授权销售的产品内容；</dd>
        <dd>（3）发布宣传国家明令禁止或未取得国家许可销售的产品内容；</dd>
        <dd>（4）发布宣传游戏代挂、代练、虚假人气、贩卖虚拟货币、平台道具等内容；</dd>
        <dd>（5）发布宣传游戏外挂、辅助等内容；</dd>
        <dd>（6）发布组织、宣传网络兼职内容；</dd>
        <dd>（7）宣传其他平台、网络游戏链接；</dd>
        <dd>（8）恶意刷屏、扰乱平台秩序；</dd>
        <dd>（9）其他违反法律法规或{{app}}平台规则的内容。</dd>
        <dd><b>3.3 </b>用户不得进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本“软件”系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本“软件”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称。</dd>
        <dd><b>3.4 </b>用户不得进行任何破坏{{app}}服务公平性或者其他影响应用正常秩序的行为，包括但不限于主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众。</dd>
        <dd><b>3.5 </b>用户不得有偿或无偿转让{{app}}账号，以免产生纠纷。用户应当自行承担由此产生的任何责任，同时{{app}}保留追究上述行为人法律责任的权利。</dd>
        <dd><b>3.6 </b>用户不得有其他损害{{app}}利益的行为。</dd>
        <dd><b>3.7 </b>若用户违反本协议的相关规定，{{app}}有权根据情节轻重，采取包括但不限于以下处罚措施：暂时限制账号的使用、永久冻结账号某项功能、永久封停账号、回收账号、剔除违法所得、扣罚保证金或佣金、终止所有服务等。</dd>
        <dd><b>3.8 </b>{{app}}按照本协议及相关平台规则或相关法律法规，限制、冻结或终止用户对{{app}}服务的使用，而由此给用户带来的损失（包括但不限于通信中断，用户资料、邮件和游戏道具及相关数据等的清空等），由用户自行承担。</dd>

        <dd><b>4、告知声明</b></dd>
        <dd><b>4.1 </b>用户须明白，在使用{{app}}服务的过程中可能存在来自他人包括威胁性的、诽谤性的、令人反感的或非法的内容或行为，或侵犯他人权利（包括知识产权）的匿名或冒名的信息风险，用户须承担以上风险，{{app}}对服务不作担保，不论是明确的或隐含的，包括所有有关信息真实性、适商性、适于某一特定用途、所有权和非侵权性的默示担保和条件，对因此导致任何因用户不正当或非法使用服务产生的直接、间接、偶然、特殊及后续的损害，不承担任何责任。</dd>
        <dd><b>4.2 </b>用户使用{{app}}服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本条款，对于用户违法或违反本协议的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。</dd>
        <dd><b>4.3 </b>{{app}}的服务同大多数因特网产品一样，易受到各种安全问题的困扰，包括但不限于：1）透露详细个人资料，被不法分子利用，造成现实生活中的骚扰；2）哄骗、破译密码；3）下载安装的其它软件中含有“特洛伊木马”等病毒，威胁到个人计算计上信息和数据的安全，继而影响对本软件的使用。对于发生上述情况的，用户应当自行承担责任。</dd>
        <dd><b>4.4 </b>用户理解，互联网技术的不稳定性，可能导致政府政策管制、病毒入侵、黑客攻击、服务器系统崩溃或者其他现今技术无法解决的风险发生，上述风险可能导致{{app}}服务中断或账号道具损失，对此等非人为因素引起的损失{{app}}不承担责任。</dd>
        <dd><b>4.5 </b>{{app}}不对发布在本网站上的广告的产品效果、宣传、信息准确性负责，用户在接触这些广告时自行判断。</dd>
        <dd><b>4.6 </b>用户同意运营商向其接收信息的装置或软件包括但不限于固定电话、移动电话、电子邮箱、QQ、微博、微信等发送服务信息和商业性广告。</dd>

        <dd><b>5、知识产权</b></dd>
        <dd><b>5.1 </b>{{app}}的文字、图片、视频、音频、软件等元素，{{app}}服务标志、标识以及专利权，{{app}}对此享有上述所有内容的知识产权。</dd>
        <dd><b>5.2 </b>用户使用{{app}}软件服务只能在本协议以及相应的授权许可协议授权的范围使用{{app}}知识产权，未经授权超范围使用的构成对{{app}}的侵权。</dd>
        <dd><b>5.3 </b>用户在使用{{app}}软件服务时发布上传的文字、图片、音视频、软件以及表演等用户原创的信息，此部分信息的知识产权归用户，但用户的发表、上传行为是对{{app}}服务平台的授权，用户确认将其发表、上传的信息非独占性、永久性地授权给{{app}}，该授权可转授权。{{app}}可将前述信息在{{app}}旗下的服务平台上使用，可再次编辑后使用，也可以由{{app}}授权给合作方使用。</dd>
        <dd><b>5.4 </b>若{{app}}软件内的信息以及其他用户上传、存储、传播的信息有侵犯用户或第三人的知识产权的，可向{{app}}官方投诉。</dd>

        <dd><b>6、知识产权</b></dd>
        <dd><b>6.1 </b>{{app}}软件部分功能或应用涉及付费，用户输入账号密码的行为视为对收费服务的接受和订阅，用户一旦接受订阅收费服务，需要按{{app}}公示的收费标准支付费用。</dd>
        <dd><b>6.2 </b>用户在进行消费时，请事先了解消费价格及事项；如用户是未成年人，请在监护人的认可后进行消费。</dd>
        <dd><b>6.3 </b>用户付费后获得的权益不得转让给第三人。</dd>

        <dd><b>7、账号安全及隐私保护</b></dd>
        <dd><b>7.1 </b>用户的{{app}}账号、密码属于保密信息，{{app}}应当采取积极的措施保护用户账号、密码的安全。用户的注册信息作为{{app}}的商业秘密进来保护。但用户同时明白，互联网的开放性以及技术更新非常快，非{{app}}可控制的因素导致用户泄漏的，{{app}}不承担责任。</dd>
        <dd><b>7.2 </b>用户应当妥善保管自己的{{app}}账号、密码，用户就其账号及密码项下之一切活动负全部责任，包括用户数据的修改，虚拟道具的损失以及其他所有的损失由用户自行承担。用户须重视{{app}}账号密码保护。用户如发现他人未经许可使用其账号时立即通知{{app}}。</dd>
        <dd><b>7.3 </b>用户{{app}}账号在丢失或遗忘密码后，可遵照{{app}}的申诉途径及时申诉请求找回账号。用户应不断提供能增加账号安全性的个人密码保护资料。用户可以凭账号身份认证信息、初始注册资料及个人密码保护资料填写申诉单向{{app}}申请找回账号。{{app}}的密码找回机制仅负责识别申诉单上所填资料与系统记录资料的正确性，而无法识别申诉人是否系真正账号使用人。对用户因被他人冒名申诉而致的任何损失，{{app}}不承担任何责任，用户知晓{{app}}账号及密码保管责任在于用户，{{app}}并不承诺{{app}}账号丢失或遗忘密码后用户一定能通过申诉找回账号。</dd>
        <dd><b>7.4 </b>如果{{app}}账号的使用者存在使用归属争议，则{{app}}将按照评判规则，根据用户提交的信息进行判定。{{app}}账号存在争议的情况下，{{app}}有权暂时中止争议账号的使用，由此带来的包括并不限于用户通讯中断、相关服务中止等损失由用户自行承担。</dd>
        <dd><b>7.5 </b>请用户注意勿在使用{{app}}软件服务中透露自己的各类财产账户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此带来的任何损失由用户自行承担。</dd>
        <dd><b>7.6 </b>用户在使用{{app}}软件服务时不可将自认为隐私的信息发表、上传至{{app}}软件，也不可将该等信息通过{{app}}软件的服务传播给其他人。若用户的行为引起的隐私泄漏，由用户承担责任。</dd>
        <dd><b>7.7 </b>{{app}}在提供服务时可能会搜集用户信息，{{app}}会明确告知用户，通常信息仅限于用户姓名、性别、年龄、出生日期、身份证号、家庭住址、教育程度、公司情况、所属行业、兴趣爱好等，用户同意{{app}}的上述行为。</dd>
        <dd><b>7.8 </b>就下列相关事宜的发生，{{app}}软件不承担任何法律责任：</dd>
        <dd>（1）{{app}}根据法律规定或相关政府机关、安全机关、司法机关的要求提供用户的个人信息；</dd>
        <dd>（2）由于用户将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄漏，或其他非因{{app}}原因导致的个人信息的泄漏；</dd>
        <dd>（3）任何由于黑客攻击、电脑病毒侵入造成的信息泄漏；</dd>
        <dd>（4）因不可抗力导致的信息泄漏。</dd>
        <dd><b>7.9 </b>{{app}}重视对用户隐私的保护，关于用户的用户资料和其他特定资料依《隐私政策》受到保护与规范，详情请参阅《隐私协议》。</dd>

        <dd><b>8、通知</b></dd>
        <dd><b>8.1 </b>用户同意{{app}}以以下合理的方式向用户送达各类通知：</dd>
        <dd>（1）公示的文案；</dd>
        <dd>（2）系统消息、弹出消息、客户端推送的消息；</dd>
        <dd>（3）根据用户预留于{{app}}软件的联系方式发出的电子邮件、手机短信、函件等。</dd>
        <dd><b>8.2 </b>对于在{{app}}软件上因交易活动引起的任何纠纷，用户同意司法机关可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向用户送达法律文书。用户指定接收法律文书的手机号码、电子邮箱等联系方式为用户在{{app}}软件注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。用户指定的邮寄地址为用户的法定联系地址或用户提供的有效联系地址。</dd>
        <dd><b>8.3 </b>用户同意司法机关可采取以上一种或多种送达方式向用户达法律文书，司法机关采取多种方式向用户送达法律文书，送达时间以上述送达方式中最先送达的为准。</dd>
        <dd><b>8.4 </b>用户应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由用户自行承担由此可能产生的法律后果。</dd>

        <dd><b>9、其他条款</b></dd>
        <dd><b>9.1 </b>本协议条款的签订、解释以及争议的解决均适用中华人民共和国法律。</dd>
        <dd><b>9.2 </b>本协议的签署地点为{{app}}软件服务器所在地即北京市朝阳区，若用户与{{app}}发生争议的，双方同意将争议提交北京市朝阳区人民法院诉讼解决。</dd>
        <dd><b>9.3 </b>本协议由{{app}}公布在网站上，对{{app}}具有法律约束力；用户一经点击接受或者直接登录的行为视为对本协议的接受，对用户具有法律约束力。</dd>

      </dl>
    </div>
    <div class="title" style="padding-top: 20px;margin-top: 20px;border-top: 1px solid #f4f4f4;">
      <h1>隐私政策</h1>
    </div>
    <div class="article">
      <dl>
        <dd>
          {{app}}公司（以下简称“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品或服务时如何收集、使用、保护这些信息。<u><b>本隐私政策适用于{{app}}等互联网业务平台。本隐私政策不适用于其他独立第三方向您提供的服务，例如我们平台上的第三方依托我们平台向您提供服务时，您向第三方提供的个人信息不适用于本隐私政策，我们对任何第三方使用由您提供的信息不承担任何责任。</b></u>
        </dd>
        <dd>
          <u><b>在使用我们的产品或服务前，请您务必仔细阅读并透彻理解本隐私政策，在确认充分理解并同意后使用相关产品或服务。如果您不同意本隐私政策任何内容，您应立即停止使用我们平台服务。一旦您开始使用我们的各项产品或服务，即表示您已充分理解并同意本隐私政策。</b></u>
        </dd>

        <dt><h3>第一部分 定义</h3></dt>
        <dd><b>您：</b>本协议的“您”特指使用{{app}}等产品或服务的用户。</dd>
        <dd><b>个人信息：</b>本协议的个人信息指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</dd>
        <dd><b>个人敏感信息：</b>指包括身份证件号码、个人生物识别信息、银行账号、通信记录和内容、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息。
        </dd>
        <dd><b>个人信息删除：</b>指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
        </dd>

        <dt><h3>第二部分 隐私政策</h3></dt>
        <dd><b>一、我们如何收集您的信息</b></dd>
        <dd>我们会出于本隐私政策所述的以下目的，收集和使用您的个人信息：</dd>
        <dd><b>（一）您向我们提供的信息。</b></dd>
        <dd>当您在我们平台或产品上注册账户及您在使用我们提供的相关服务时填写或提交的信息，包括您的姓名、性别、出生年月日、<u><b>身份证号码</b></u>、电话号码、电子邮箱、<u><b>地址</b></u>、兴趣爱好、<u><b>银行账号</b></u>及相关附加信息（如您所在的省份和城市、邮政编码等）。
        </dd>
        <dd><b>请注意：</b>我们的多项服务，可让您不仅与自己的社交网络分享信息，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们平台上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的<u><b>位置数据</b></u>、视频、音频信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据、视频、音频信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。<u><b>只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。</b></u>
        </dd>
        <dd>
          <u><b>因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请和我们取得联系。</b></u>
        </dd>
        <dd><b>（二） 在您使用服务过程中收集的信息。</b></dd>
        <dd>为了更好的为您提供服务，我们会收集您的相关信息，这类信息包括：</dd>
        <dd>在您使用我们平台的服务或访问平台网页时，我们会自动接收并记录的您的浏览器、计算机、移动设备的信息，包括但不限于您的<u><b>IP地址</b></u>、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您的网页记录等数据；如您下载或使用我们或我们关联公司客户端软件，或访问移动网页使用我们平台的服务时，我们可能会读取<u><b>与您位置和移动设备相关的信息，包括但不限于设备型号、设备识别码、操作系统、分辨率、电信运营商等。</b></u>
        </dd>
        <dd>我们会收集您通过我们平台上传的内容、信息，例如上传或拍摄的文字、共享照片、录音、录像以及该类信息的日期、时间或地点等。</dd>
        <dd><u><b>除上述信息外，为了改进服务质量，我们还可能收集您的其他信息，包括且并不限于您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联公司、合作方互动时提供的相关信息。</b></u>与此同时，为提高您使用相关服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。
        </dd>

        <dd><b>（三）我们从第三方获得您个人信息的情形。</b></dd>
        <dd>
          为了给您提供更好的服务或为了预防互联网犯罪，我们的关联公司、合作伙伴会依据法律的规定或征得您同意的前提下，向我们分享您的个人信息。我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的账户绑定，使您可以通过第三方账户直接登录并使用我们的产品或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
        </dd>

        <dd><b>二、我们如何使用信息</b></dd>
        <dd>为了提高服务质量，我们可能把您的信息用于下列用途：</dd>
        <dd>1. 向您提供服务；</dd>
        <dd>2. 用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</dd>
        <dd>3. 向您推荐您可能感兴趣的内容，包括但不限于向您发出产品、服务信息或有关广告，通过系统向您展示个性化的第三方推广信息或者在征得您同意的情况下与我们的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息；</dd>
        <dd>4. 我们可能会将您的个人信息与其他服务信息结合起来，用于为了给您提供更加个性化的服务使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露</dd>
        <dd>5. 让您参与有关我们产品和服务的调查，促销及抽奖活动；</dd>
        <dd>6. 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示或对您和其他用户作出其他方面的回应；</dd>
        <dd>7. 软件认证或管理软件升级；</dd>
        <dd>8. 让您参与有关我们产品和服务的调查；</dd>
        <dd>9. 经您许可的其他用途。</dd>

        <dd><b>三、我们如何共享、转让、公开披露您的信息</b></dd>
        <dd><b>（一）共享</b></dd>
        <dd>我们不会与我们以外的公司、组织和个人共享您的个人信息，但以下情况除外：</dd>
        <dd>1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</dd>
        <dd>2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</dd>
        <dd>3、在您主动选择情况下共享： 您通过{{app}}购买服务，我们会根据您的选择，将您的必要信息共享给相关服务的提供者，以实现您的交易及售后服务需求。</dd>
        <dd>
          4、与关联公司间共享：为便于我们基于{{app}}账户向您提供产品和服务，推荐您可能感兴趣的信息，识别会员账号异常，保护{{app}}关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
        </dd>
        <dd>
          5、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。
        </dd>
        <dd>目前，我们的授权合作伙伴包括以下类型：</dd>

        <dd>
          （1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，但不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以进行广告或决策建议。
        </dd>

        <dd>
          （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
        </dd>

        <dd>我们会与其约定严格的数据保护措施，令其按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</dd>

        <dd><b>（二）转让</b></dd>
        <dd>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</dd>
        <dd>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</dd>
        <dd>
          2、在{{app}}公司发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
        </dd>

        <dd><b>（三）公开披露</b></dd>
        <dd>我们仅会在以下情况下，公开披露您的个人信息：</dd>
        <dd>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</dd>
        <dd>
          2、如果我们确定您出现违反法律法规或严重违反{{app}}相关协议及规则的情况，或为保护其他用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及{{app}}已对您采取的措施。
        </dd>

        <dd><b>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</b></dd>
        <dd>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</dd>
        <dd>1、与国家安全、国防安全有关的；</dd>
        <dd>2、与公共安全、公共卫生、重大公共利益有关的；</dd>
        <dd>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</dd>
        <dd>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</dd>
        <dd>5、您自行向社会公众公开的个人信息；</dd>
        <dd>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</dd>

        <dd>请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</dd>

        <dd><b>四、Cookie的使用</b></dd>
        <dd>
          为使您获得更轻松的访问体验，您访问我们平台网站或使用我们平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
          Cookie，您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
        </dd>
        <dd>
          请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我们的Cookie，但这一举动在某些情况下可能会影响您安全访问我们平台相关网站和使用我们平台提供的服务。
        </dd>
        <dd>我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web
          beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web
          beacon收集和使用该等信息，不受本隐私政策约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web beacon承担责任。
        </dd>
        <dd>您可以通过浏览器设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web
          beacon，您有可能无法享受佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。
        </dd>

        <dd><b>五、我们如何保护和保存您的个人信息</b></dd>
        <dd>
          为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。
        </dd>
        <dd>
          您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
        </dd>
        <dd>
          在使用我们平台服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如银行账户信息、联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络我们客服，以便我们采取相应措施。
        </dd>

        <dd><b>六、未成年人隐私权特别约定</b></dd>
        <dd><u><b>我们要求父母或监护人在阅读本隐私政策后指导未满十八岁的未成年人使用我们的服务。</b></u></dd>
        <dd><u><b>我们不会在知情的情况下收集未成年人的个人信息。除非所在地法律允许并且监护人同意，未成年人请不要注册账户或发送自己的姓名、住址、电话、邮件地址等个人信息给我们。如果我们不小心收集到了未成年人的信息，我们在知情后会尽快删除。如果您认为我们可能不当地持有关于未成年人的信息，请联系我们。</b></u>
        </dd>

        <dd><b>七、隐私政策特别条款</b></dd>
        <dd>您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</dd>
        <dd>1. 与国家安全和社会公共利益有关的；</dd>
        <dd>2. 与犯罪侦查、起诉、审判和判决执行等有关的；</dd>
        <dd>3. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</dd>
        <dd>4. 所收集的个人信息是个人信息主体自行向社会公众公开的；</dd>
        <dd>5. 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</dd>
        <dd>6. 违反法律规定或违反我们平台规则导致我们已对您采取必要措施；</dd>
        <dd>7. 根据您的要求签订合同所必需的；</dd>
        <dd>8. 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</dd>
        <dd>9. 为合法的新闻报道所必需的；</dd>
        <dd>10. 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</dd>
        <dd>11. 法律法规规定的其他情形。</dd>

        <dd><b>八、隐私政策的变更</b></dd>
        <dd>
          我们可能适时修订本隐私政策的条款，该修订构成本隐私政策的一部分。如该等修订造成您在本隐私政策下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策的约束。
        </dd>

        <dd><b>九、管辖与法律适用</b></dd>
        <dd><u><b>本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</b></u></dd>
        <dd><u><b>若您和我们发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本隐私政策签订地（中国北京市朝阳区）有管辖权的人民法院管辖。</b></u></dd>

        <dd><b>十、如何联系我们</b></dd>
        <dd>若您对我们的隐私政策有任何疑问，可随时联系我们。</dd>
        <dd>邮寄地址：北京市朝阳区姚家园路105号乐融大厦</dd>
        <dd>法务部收</dd>
        <dd>邮编：10000</dd>
      </dl>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'privacy',
    props: ['app'],
    mounted () {
      document.title = document.querySelector('.title').textContent
    }
  }
</script>
